import { jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Main section container component
 * @param children - The section content
 * @param className - Additional CSS classes
 * @returns JSX element with section container
 */
const Section = ({ children, className }) => {
    return jsx("div", { className: cn('', className), children: children });
};
/**
 * Section title component for section titles
 * @param children - The title content
 * @param className - Additional CSS classes
 * @returns JSX element with styled title
 */
const SectionTitle = ({ children, className }) => {
    return (jsx("h2", { className: cn('text-2xl font-semibold tracking-tight mb-3', className), children: children }));
};
/**
 * Section description component for section descriptions
 * @param children - The description content
 * @param className - Additional CSS classes
 * @returns JSX element with styled description
 */
const SectionDescription = ({ children, className }) => {
    return jsx("p", { className: cn('text-muted-foreground mb-4', className), children: children });
};

export { Section, SectionDescription, SectionTitle };
//# sourceMappingURL=Section.js.map
